import { ErrorHandler, Injectable, isDevMode } from '@angular/core';

import { MonitoringService } from './monitoring.service';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService extends ErrorHandler {
  constructor(private monitoringService: MonitoringService) {
    super();
  }

  handleError(error: Error): void {
    if (isDevMode()) {
      console.error(error);
    }

    if (this.monitoringService.isInitialise) {
      this.monitoringService.logException(error); // Manually log exception
    }
  }
}
